import { useIntl } from "react-intl";

const AdvancedAlertIntegrations = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AdvancedAlertIntegrations.header",
            defaultMessage: "Advanced alert integrations"
        }),
        content: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AdvancedAlertIntegrations.content",
            defaultMessage:
                "Connect hundreds of third-party tools to Jira Service Management with:"
        }),
        listItems: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AdvancedAlertIntegrations.listItems",
                defaultMessage:
                    "<li>Global integrations that let you route alerts to different teams</li> <li>Outbound integrations like outgoing webhooks to send alerts to another tool or endpoint</li> <li>Bi-directional integrations that sync back and forth</li> <li>Alerts from integrations via filters in the advanced view</li>"
            },
            { li: (chunk: React.ReactNode) => <li>{chunk}</li> }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <ul>{messages.listItems}</ul>
        </>
    );
};

export default AdvancedAlertIntegrations;
